import 'swiper/swiper-bundle.min.css'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Carousel, Modal } from 'react-bootstrap'
import { SIZES } from 'src/styles/theme'
import Amplitude from 'src/utils/amplitudeHelper'
import styled from 'styled-components'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Scrollbar, A11y, Autoplay, Navigation, FreeMode } from 'swiper'
import { fixedAssets } from 'src/containers/PreCache'
import { useDispatch, useSelector } from 'react-redux'
import { getSpeakers, setSpeaker } from 'src/ducks/speakers'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import { Loader } from '../shared/Loader'
import Media from 'react-media'
import { IoCloseCircle } from 'react-icons/io5'

SwiperCore.use([Autoplay, Scrollbar, A11y, Navigation, FreeMode])

export const SpeakersProfileModal = ({ showModal, hideModal }) => {
  const dispatch = useDispatch()

  const { speakers, selectedSpeaker } = useSelector((state) => state.speakers)

  const [open, setOpen] = useState(false)

  const [loading, setLoading] = useState(true)
  const [activeSlide, setActiveSlide] = useState(0)
  const swiperRef = useRef()

  const onInit = (Swiper) => {
    swiperRef.current = Swiper
  }

  const handleMouseEnter = () => {
    if (swiperRef.current?.autoplay) {
      swiperRef.current.autoplay.stop()
    }
  }
  const handleMouseLeave = () => {
    if (swiperRef.current?.autoplay) {
      swiperRef.current.autoplay.start()
    }
  }

  useEffect(() => {
    Amplitude.clickSpeaker()
    setOpen(true)
  }, [])

  useEffect(() => {
    if (speakers && speakers.length === 0) {
      dispatch(getSpeakers())
    }
    setLoading(false)
  }, [])

  const toggleModal = useCallback(() => {
    setOpen(false)
    dispatch(setSpeaker(null))
    setTimeout(hideModal, 900)
  }, [hideModal])

  const selectSpeakerHandler = (speaker) => {
    dispatch(setSpeaker(speaker))
  }
  const findSpeaker = (id) => {
    return speakers.find((speaker) => speaker.id === id)
  }

  const getSpeakerIndex = (id) => {
    return speakers.findIndex((speaker) => speaker.id === id)
  }

  const onNextHandler = (id) => {
    const speaker = findSpeaker(id)
    dispatch(setSpeaker(speaker))
  }

  const onPrevHandler = (id) => {
    const speaker = findSpeaker(id)
    dispatch(setSpeaker(speaker))
  }

  const onRightHandler = () => {
    if (swiperRef.current) {
      const swiper = swiperRef.current
      const totalSlides = swiper.slides.length
      let slideTo = swiper.activeIndex + 1

      if (slideTo >= totalSlides) {
        slideTo = 0
      }

      swiper.slideTo(slideTo, 1000)
    }
  }

  const onLeftHandler = () => {
    if (swiperRef.current) {
      const swiper = swiperRef.current
      const totalSlides = swiper.slides.length
      let slideTo = swiper.activeIndex - 2

      if (slideTo < 0) {
        slideTo = totalSlides - 1
      }

      swiper.slideTo(slideTo, 1000)
    }
  }

  const onMobileRightHandler = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext(400)
    }
  }

  const onMobileLeftHandler = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev(400)
    }
  }

  const renderSpeakerSlides = () =>
    speakers.map((speaker) => (
      <SwiperSlide key={speaker.id}>
        <div className="speaker-wrapper" onClick={() => selectSpeakerHandler(speaker)}>
          <img className="speaker-slide img-fluid" src={speaker.image} alt={speaker.name} />
          <div className="overlay">
            <p className="speaker-name">{speaker.name}</p>
            <p className="position" dangerouslySetInnerHTML={{ __html: speaker.title }}></p>
            <p dangerouslySetInnerHTML={{ __html: speaker.subtitle }}></p>
          </div>
        </div>
      </SwiperSlide>
    ))

  return (
    <>
      <SharedModal
        open={open}
        show={showModal}
        onHide={toggleModal}
        size="lg"
        aria-labelledby="gallery-pdf-modal"
        className={selectedSpeaker ? 'speaker-detail-modal' : 'speaker-gallery-modal'}
        centered
        animation={false}
      >
        <button className="btn c-button close-modal-btn desktop-close-modal-btn" type="button" onClick={toggleModal} aria-label="Close speakers">
          <FaChevronRight aria-hidden="true" />
        </button>
        <Modal.Body>
          {speakers.length > 0 && !selectedSpeaker ? (
            loading ? (
              <Loader />
            ) : (
              <>
                <div className="custom-header">
                  <p className="mod-title">Speakers</p>
                  <button className="mobile-modal-close" type="button" onClick={toggleModal} aria-label="Close speakers">
                    <IoCloseCircle aria-hidden="true" />
                  </button>
                </div>
                {/* <div className="d-flex flex-row justify-content-center p-3 day">
              <button className="btn c-button" onClick={prevSpeakerHandler}><FaChevronLeft /></button>
              <button className="btn c-button" onClick={nextSpeakerHandler}><FaChevronRight /></button>
            </div> */}
                {!selectedSpeaker && (
                  <div className="speaker-header desktop-speaker-header mb-5">
                    <img src={fixedAssets.speakerHeader} alt="Speaker Header" className="img-fluid" />
                  </div>
                )}
                <div className="s-carousel-container" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                  <Media query={`(max-width: ${SIZES.mobileBreakpoint})`}>
                    {(matches) =>
                      matches ? (
                        <>
                          <Swiper
                            speed={400}
                            simulateTouch={true}
                            className="mySwiper mobile-speaker-swiper"
                            modules={[A11y, Navigation]}
                            slidesPerView="auto"
                            spaceBetween={31}
                            slidesOffsetBefore={20}
                            slidesOffsetAfter={20}
                            loop={false}
                            centeredSlides={false}
                            navigation={false}
                            onInit={onInit}
                            onSlideChange={(swiper) => setActiveSlide(swiper.activeIndex)}
                          >
                            {renderSpeakerSlides()}
                          </Swiper>
                          <div className="speaker-carousel-controls">
                            <button
                              className="btn c-button"
                              type="button"
                              onClick={onMobileLeftHandler}
                              disabled={activeSlide === 0}
                              aria-label="Previous speaker"
                            >
                              <FaChevronLeft aria-hidden="true" />
                            </button>
                            <button
                              className="btn c-button"
                              type="button"
                              onClick={onMobileRightHandler}
                              disabled={activeSlide >= speakers.length - 1}
                              aria-label="Next speaker"
                            >
                              <FaChevronRight aria-hidden="true" />
                            </button>
                          </div>
                        </>
                      ) : (
                        <>
                          <Swiper
                            speed={6000}
                            simulateTouch={true}
                            className="mySwiper"
                            modules={[Scrollbar, Autoplay, A11y, Navigation, FreeMode]}
                            slidesPerView={4}
                            watchSlidesProgress={false}
                            spaceBetween={16}
                            freeMode={true}
                            loop={true}
                            centeredSlides={false}
                            initialSlide={0}
                            autoplay={{
                              delay: 1,
                              pauseOnMouseEnter: true,
                              disableOnInteraction: false,
                            }}
                            navigation={false}
                            breakpoints={{
                              768: {
                                touchRatio: 1,
                              },
                              1280: {
                                slidesPerView: 3,
                              },
                              1440: {
                                slidesPerView: 4,
                              },
                              2560: {
                                slidesPerView: 4,
                              },
                            }}
                            onInit={onInit}
                            scrollbar={{
                              draggable: true,
                            }}
                          >
                            {renderSpeakerSlides()}
                          </Swiper>
                          <div className="speaker-carousel-controls">
                            <button className="btn c-button" type="button" onClick={onLeftHandler} aria-label="Previous speakers">
                              <FaChevronLeft aria-hidden="true" />
                            </button>
                            <button className="btn c-button" type="button" onClick={onRightHandler} aria-label="Next speakers">
                              <FaChevronRight aria-hidden="true" />
                            </button>
                          </div>
                        </>
                      )
                    }
                  </Media>
                </div>
              </>
            )
          ) : (
            selectedSpeaker && (
              <Media query={`(max-width: ${SIZES.mobileBreakpoint})`}>
                {(matches) =>
                  matches ? (
                    <>
                      {/* <div className="d-none d-mb-block speaker-header">
                        <img src={fixedAssets.speakerHeader} alt="Speaker Header" class="img-fluid" />
                      </div> */}
                      <p className="file-description d-none d-md-block">Speakers</p>
                      <SpeakerDetail>
                        <div className="detail-wrapper">
                          <div className="info">
                            <h4 className="name">{selectedSpeaker.name}</h4>
                            <p className="title" dangerouslySetInnerHTML={{ __html: selectedSpeaker.title }}></p>
                            <p className="subtitle" dangerouslySetInnerHTML={{ __html: selectedSpeaker.subtitle }}></p>
                            <div className="divider"></div>
                            <p className="bio">{selectedSpeaker.bio}</p>
                          </div>
                          <div className="avatar-wrapper">
                            <div className="avatar">
                              <img src={selectedSpeaker.mobileAvatar} alt={selectedSpeaker.name} className="img-fluid" />
                            </div>
                          </div>
                        </div>
                        {/* Speaker controls */}
                        <div className="speaker-controls">
                          <button className="btn c-button" onClick={() => onPrevHandler(selectedSpeaker.prev)} disabled={!selectedSpeaker.prev}>
                            <FaChevronLeft />
                          </button>
                          <button className="btn c-button" onClick={() => dispatch(setSpeaker(null))}>
                            All Speakers
                          </button>
                          <button className="btn c-button" onClick={() => onNextHandler(selectedSpeaker.next)} disabled={!selectedSpeaker.next}>
                            <FaChevronRight />
                          </button>
                        </div>
                      </SpeakerDetail>
                    </>
                  ) : (
                    <>
                      <Carousel
                        touch
                        wrap={false}
                        controls={false}
                        activeIndex={getSpeakerIndex(selectedSpeaker.id)}
                        indicators={false}
                        prevIcon={
                          <div className="zoom-btn" style={{ transform: 'rotate(180deg)', opacity: 1 }}>
                            &#10142;
                          </div>
                        }
                        nextIcon={
                          <div className="zoom-btn" style={{ opacity: 1 }}>
                            &#10142;
                          </div>
                        }
                      >
                        {speakers.map((speaker, index) => (
                          <Carousel.Item key={speaker.id}>
                            <div className="d-flex justify-content-center items-align-center">
                              <img className="img-fluid" src={speaker.desktopBio} alt={`Speaker ${index + 1}`} style={{ maxWidth: '99%' }} />{' '}
                            </div>
                          </Carousel.Item>
                        ))}
                      </Carousel>
                      <div className="speaker-profile-controls">
                        <button className="btn c-button" onClick={() => onPrevHandler(selectedSpeaker.prev)} disabled={!selectedSpeaker.prev}>
                          <FaChevronLeft />
                        </button>
                        <button className="btn c-button py-2 px-4 font-bold" onClick={() => dispatch(setSpeaker(null))}>
                          All Speakers
                        </button>
                        <button className="btn c-button" onClick={() => onNextHandler(selectedSpeaker.next)} disabled={!selectedSpeaker.next}>
                          <FaChevronRight />
                        </button>
                      </div>
                    </>
                  )
                }
              </Media>
            )
          )}
        </Modal.Body>
      </SharedModal>
    </>
  )
}

const SpeakerDetail = styled.div`
  background: transparent;
  backdrop-filter: none;
  .detail-wrapper {
    display: flex;
    flex-direction: column;
    gap: 3rem;
    color: #fff;
    padding: 1rem;
    align-items: center;

    div:first-child {
      order: 2;
    }
    div:last-child {
      order: 1;
    }
  }

  .divider {
    height: 5px;
    width: 90%;
    background: var(--light-blue-900);
    margin: 1rem 0;
  }

  .name {
    color: var(--yellow);
    font-size: 20px;
  }

  .title {
    font-style: italic;
  }
  .title,
  .subtitle {
    font-size: 16px;
    color: #fff;
    margin: 0;
  }

  .bio {
    font-size: 16px;
    text-align: justify;
  }

  .flex-1 {
    flex: 1 0 auto;
  }

  .avatar {
    border: 3px solid #cacacc;
    width: 223px;
    height: 222px;
    overflow: hidden;
    border-radius: 12rem;
  }

  .speaker-controls {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    justify-content: center;
    margin-top: 1rem;
    /* Canonical button style — matches the login page submit button
       (src/pages/LoginPage/LoginPage.tsx '.submit-btn') for visual
       consistency across the app. This 'button' rule (rather than the
       global '.c-button' class) previously forced a dark text color
       that would otherwise win over the navy '.c-button' override above
       due to higher selector specificity, so background/shadow are
       applied here too to keep the prev/next/"All Speakers" controls
       in sync. */
    button {
      background: var(--Gold-Gradient-01);
      color: #fff !important;
      font-weight: 700;
      border-radius: 10px;
      box-shadow: 0px 4px 6.15px rgba(0, 0, 0, 0.21);
    }
    padding: 1rem 0;

    button:nth-child(2) {
      padding: 0.6rem 2rem;
    }
  }

  @media (min-width: 768px) {
    .detail-wrapper {
      flex-direction: row;
      gap: 5rem;
      min-height: 600px;
      div:first-child {
        order: 1;
      }
      div:last-child {
        order: 2;
      }
    }

    .avatar {
      width: 350px;
      height: 350px;
    }
  }
`
const SharedModal = styled(Modal)`
  left: ${(props) => (props.open ? '0' : '100%')};
  transition: 1s !important;
  scrollbar-width: thin;
  .modal-dialog {
    width: 90%;
    max-width: unset;
    margin: 0 !important;
    margin-left: auto !important;
    border-radius: 0;

    @media (max-width: ${SIZES.mobileBreakpoint}) {
      width: 100%;
    }
  }
  .mod-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #fff;
    flex: 1 1 0;
  }
  .custom-header {
    display: none;
  }
  .modal-content {
    border-radius: 0;
    width: 100%;
    min-height: 100vh;
    max-width: 100%;
    background: rgba(17, 24, 39, 0.9);
  }

  /* Canonical button style — matches the login page submit button
     (src/pages/LoginPage/LoginPage.tsx '.submit-btn') for visual
     consistency across the app. Scoped to this modal only (rather than
     overriding the shared global '.c-button' class in src/index.css)
     so the many other unrelated '.c-button' usages elsewhere in the
     app are left untouched. Covers the close chevron and the
     prev/next carousel controls below. */
  .c-button {
    background: var(--Gold-Gradient-01);
    color: #fff !important;
    border-radius: 10px;
    box-shadow: 0px 4px 6.15px rgba(0, 0, 0, 0.21);
  }

  .close-modal-btn {
    position: absolute;
    left: -20px;
    z-index: 99999;
    bottom: 50%;
  }

  .speaker-carousel-controls {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    margin: 1rem 0;
    justify-content: center;
    padding-inline: 1rem;

    @media (min-width: 1280px) {
      justify-content: space-between;
      margin-top: 1%;
      z-index: 1;
      position: relative;

      button {
        padding: 0.7rem 1rem;
      }
    }
  }

  .speaker-profile-controls {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    justify-content: center;
    margin: 1rem 0;
  }

  .s-carousel-container {
  }

  .swiper-wrapper {
    height: auto;
    width: 300px;
    -webkit-transition-timing-function: linear !important;
    -o-transition-timing-function: linear !important;
    transition-timing-function: linear !important;
  }

  .swiper-slide {
    max-width: 346px;
    max-height: 497px;
  }

  .speaker-wrapper {
    position: relative;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    max-height: 497px;

    img {
      width: 100%;
    }

    .overlay {
      position: absolute;
      z-index: 1;
      bottom: 0;
      width: 100%;
      min-height: 150px;
      padding: 20px;
      background: rgba(17, 24, 39, 0.7);
      color: #fff;
      font-family: 'Din', 'DIN', sans-serif;
      text-align: left;
      transition: all 0.2s ease-in-out;

      .speaker-name {
        display: block;
        align-self: stretch;
        width: 100%;
        margin: 0 0 10px;
        color: #fff !important;
        font-size: 22px;
        font-weight: 700;
        line-height: 1;
        text-align: left !important;
      }

      p {
        width: 100%;
        margin: 0;
        font-size: 18px;
        font-weight: 400;
        line-height: 1;
        text-align: left !important;
      }

      .position {
        font-style: normal;
      }

      .override {
        font-size: 18px !important;
      }
    }

    @media (min-width: 768px) {
      &:hover .overlay {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        background: rgba(17, 24, 39, 0.7);
      }
    }
  }

  .modal-header {
    padding: 12px;
    border: none;
    display: block;
    background: rgba(0, 0, 0, 0.55);
    border-radius: 0;
    position: sticky;
    top: 0;
    z-index: 1000;

    button.close {
      opacity: 1;
      padding: 4px auto !important;
      z-index: 100;
      position: absolute;
      top: 5px;
      right: 20px;
      span {
        font-weight: 400;
        font-size: 34px;
        color: #fff;
        text-shadow: none;
      }
    }
  }
  p.file-description {
    padding: 8px auto;
    font-size: 16px;
    margin: 0;
    color: #fff;
    font-weight: 500;
    text-transform: uppercase;
    text-align: center;
  }

  .modal-body {
    padding: 0;
    width: 100%;
    max-width: 100%;
  }
  .flex-container {
    display: flex;
    justify-content: center;
  }
  .buttons {
    position: absolute;
    top: 5px;
    left: 5px;
    display: flex;
    z-index: 1000;
  }

  header {
    display: none;
    justify-content: center;
    flex-wrap: wrap;
    padding-bottom: 0.5rem;
  }
  header {
    .active {
      color: #f8c605;
      border-bottom: 2px solid #f8c605;
    }
  }
  .appear {
    opacity: 0;
    animation: appear 500ms forwards;
  }
  ${SIZES.mobile} {
    .modal-dialog {
      width: 100%;
      max-width: 100%;
      min-height: 100vh;
      min-height: 100dvh;
    }

    .modal-content {
      height: 100vh;
      height: 100dvh;
      min-height: 100vh;
      min-height: 100dvh;
      overflow: hidden;
      border: 0;
      background: transparent;
      backdrop-filter: none;
    }

    .custom-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 94px;
      padding: 64px 20px 0;
    }

    .mod-title {
      flex: none;
      margin: 0;
      padding: 0;
      font-family: 'Din', sans-serif;
      font-size: 30px;
      font-weight: 700;
      line-height: 1;
      text-transform: uppercase;
    }

    .mobile-modal-close {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      padding: 0;
      border: 0;
      border-radius: 50%;
      color: #fff;
      background: transparent;
      cursor: pointer;

      svg {
        width: 30px;
        height: 30px;
      }
    }

    .desktop-speaker-header {
      display: none;
    }

    .desktop-close-modal-btn {
      display: none;
    }

    .s-carousel-container {
      width: 100%;
      margin-top: 110px;
    }

    .mobile-speaker-swiper {
      width: 100%;
      overflow: hidden;
    }

    .swiper-wrapper {
      width: auto;
      height: 460px;
      transition-timing-function: ease !important;
    }

    .swiper-slide {
      width: 250px !important;
      max-width: 250px;
      height: 460px;
      max-height: 460px;
    }

    .speaker-wrapper {
      width: 250px;
      height: 460px;
      max-height: 460px;
      overflow: hidden;

      .speaker-slide {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .overlay {
        min-height: 161px;
        padding: 20px;
        background: rgba(17, 24, 39, 0.7);
        text-align: left;
        font-family: 'Din', sans-serif;

        .speaker-name {
          display: block;
          align-self: stretch;
          width: 100%;
          margin: 0 0 10px;
          color: #fff !important;
          font-size: 22px;
          font-weight: 700;
          line-height: 1;
          text-align: left !important;
        }

        p,
        .position {
          width: 100%;
          margin: 0;
          font-size: 18px;
          font-style: normal;
          line-height: 1;
          text-align: left !important;
        }
      }
    }

    .speaker-carousel-controls {
      gap: 26px;
      margin: 43px 0 0;
      padding: 0;

      button {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 40px;
        width: 40px;
        height: 40px;
        padding: 8px;
        border: 0;

        &:disabled {
          opacity: 0.5;
        }
      }
    }

    header {
      display: flex;
      position: sticky;
      top: 49.5px;
      z-index: 1000;
      background: rgba(0, 0, 0, 0.55);
    }
    .modal-header {
      display: none;
    }
    .modal-body {
      position: static;
      height: 100%;
      overflow: hidden;
    }
    &.speaker-detail-modal .modal-body {
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }
    p.file-description {
      font-size: 14px;
      text-align: left;
    }
    .buttons {
      position: static;
    }
    .zoom-btn {
      margin: 0 2px;
      width: 30px;
      height: 30px;
    }
  }
`
